import React from "react";
import logo from "../../../Images/L.png";
import {
  FaFacebookF,
  FaInstagram,
  FaEnvelope,
  FaPhoneAlt,
  FaWhatsapp,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "../Footer/footer.css";

const Footer = () => {
  return (
    <footer className="footer-section text-white pt-5 pb-3">
      <div className="container">

        <div className="row gy-4 text-center text-md-start align-items-start">

          {/* 1️⃣ Logo Section */}
          <div className="col-lg-3 col-md-6">
            <img src={logo} alt="Akshayam Silks" className="footer-logo mb-3" />
            <p className="small footer-desc">
              Where tradition meets elegance — weaving trust and style for generations.
            </p>
          </div>

          {/* 2️⃣ Contact Section */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Contact</h5>
            <ul className="list-unstyled footer-contact">

              {/* 📍 Location */}
              <li className="footer-location">
                <FaMapMarkerAlt className="location-icon" />
                <a href="https://www.google.com/maps/place/Akshayam+Silks+And+Readymades/@8.1667217,77.417589,1752m/data=!3m1!1e3!4m6!3m5!1s0x3b04f1535672a3b7:0x626a9420157505f3!8m2!3d8.1671396!4d77.4193089!16s%2Fg%2F11ydl9z7gd?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D"  width="100%"  target="_blank" 
    rel="noopener noreferrer"
>
                  203A/1 Rajakkamangalam Road, Punnainagar Junction, Nagercoil-629004
                </a>
              </li>

              {/* 📧 Email */}
              <li className="footer-mail">
                <FaEnvelope className="envelope-icon" />
                <a href="mailto:akshayamsilksreadymades@gmail.com">
                  akshayamsilksreadymades@gmail.com
                </a>
              </li>

              {/* 📞 Phone */}
              <li className="footer-phone">
                <FaPhoneAlt className="phone-icon" />
                <a href="tel:+914652318654">04652-318654</a>
              </li>

            </ul>
          </div>

          {/* 3️⃣ Quick Links */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="list-unstyled footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          {/* 4️⃣ Follow Us Section */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Follow Us</h5>
            <div className="footer-social d-flex justify-content-center justify-content-md-start">
              <a href="https://www.facebook.com/share/17HNFGxLhK/" target="_blank" rel="noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/akshayamsilks_nagercoil" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>
              <a href="https://wa.me/918610893897" target="_blank" rel="noreferrer">
                <FaWhatsapp />
              </a>
            </div>
          </div>

        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom text-center mt-4 pt-3 border-top border-light">
<p>© 2025 <a href="https://enterkeysolutions.com/" style={{color:"white"}}> Enterkey Solutions</a>. All rights reserved.</p>        </div>

      </div>
    </footer>
  );
};

export default Footer;
